module.exports = __webpack_public_path__ + "img/107021.5874f7ad.png";